import { render } from "./SalesReturnDetails.vue?vue&type=template&id=1a60929b"
import script from "./SalesReturnDetails.vue?vue&type=script&lang=js"
export * from "./SalesReturnDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__